import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description MarkPin icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { MarkPin } from '@sravni/design-system-icons'
 *
 * <MarkPin />
 * ```
 */
var MarkPin = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "MarkPin", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.272 8.37v-.143a5.727 5.727 0 1 1 11.456 0v.144c0 2.884-3.652 7.226-5.124 8.859a.811.811 0 0 1-1.208 0c-1.472-1.633-5.124-5.975-5.124-8.86Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.333 8.296a1.666 1.666 0 1 0 3.334 0v-.031a1.666 1.666 0 1 0-3.334 0", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { MarkPin };
//# sourceMappingURL=MarkPin.js.map
